import { render, staticRenderFns } from "./SumMary.vue?vue&type=template&id=9b501296"
import script from "./SumMary.vue?vue&type=script&lang=js"
export * from "./SumMary.vue?vue&type=script&lang=js"
import style0 from "./SumMary.vue?vue&type=style&index=0&id=9b501296&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports